import { Link } from '@ets-global/b2c-website-ui';
import classNames from 'classnames';
import React from 'react';

import { useRouter } from '../../../hooks';
import { paths } from '../../../paths';
import Flag from '../../Base/Flag/Flag';
import LocaleSetter from './LocaleSetter';

const SelectLanguage = ({ country = true, className }) => {
  const { countryIso2 } = useRouter();

  return (
    <div className={classNames('header__top-language', className)}>
      {country && (
        <>
          <div className={'header__top-link'}>
            <Link
              data-cypress={'header.change-country'}
              to={paths.COUNTRY}
              aria-label={`select language: ${countryIso2.toLowerCase()}`}
            >
              <Flag country={countryIso2.toLowerCase()} />
            </Link>
          </div>

          <span className={'header__top-separator'} />
        </>
      )}
      <LocaleSetter />
    </div>
  );
};

export default React.memo(SelectLanguage, () => true);
